var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { PollStatus, PostDataType } from '@amityco/js-sdk';
import customizableComponent from '../../../../core/hocs/customization';
import withSDK from '../../../../core/hocs/withSDK';
import usePost from '../../../../social/hooks/usePost';
import usePoll from '../../../../social/hooks/usePoll';
import { usePostRenderer } from '../../../../social/providers/PostRendererProvider';
import DefaultPostRenderer from './DefaultPostRenderer';
import PostErrorBoundary from './PostErrorBoundary';
import UnknownPostRenderer from './UnknownPostRenderer';
const Post = ({ postId, currentUserId, userRoles, className, hidePostTarget, readonly, handleCopyPostPath, handleCopyCommentPath, }) => {
    var _a, _b;
    const renderers = usePostRenderer();
    const _c = usePost(postId), { isPostReady, post } = _c, others = __rest(_c, ["isPostReady", "post"]);
    const pollPost = others.childrenPosts.find((childPost) => childPost.dataType === PostDataType.PollPost);
    const { handleClosePoll, poll } = usePoll((_a = pollPost === null || pollPost === void 0 ? void 0 : pollPost.data) === null || _a === void 0 ? void 0 : _a.pollId);
    const isPollClosed = poll.status === PollStatus.Closed;
    if (!isPostReady) {
        return React.createElement(DefaultPostRenderer, { loading: true });
    }
    const Renderer = (_b = renderers[post.dataType]) !== null && _b !== void 0 ? _b : UnknownPostRenderer;
    return (React.createElement(PostErrorBoundary, null,
        React.createElement(Renderer, Object.assign({}, others, { handleClosePoll: handleClosePoll, isPollClosed: isPollClosed, poll: poll, className: className, currentUserId: currentUserId, hidePostTarget: hidePostTarget, post: post, userRoles: userRoles, readonly: readonly, handleCopyPostPath: handleCopyPostPath, handleCopyCommentPath: handleCopyCommentPath }))));
};
Post.propTypes = {
    postId: PropTypes.string.isRequired,
    currentUserId: PropTypes.string,
    className: PropTypes.string,
    userRoles: PropTypes.arrayOf(PropTypes.string),
    hidePostTarget: PropTypes.bool,
    readonly: PropTypes.bool,
    handleCopyPostPath: PropTypes.func,
    handleCopyCommentPath: PropTypes.func,
};
Post.defaultProps = {
    currentUserId: '',
    userRoles: [],
    className: '',
    hidePostTarget: false,
};
export default memo(withSDK(customizableComponent('Post', Post)));
//# sourceMappingURL=index.js.map